import { render, staticRenderFns } from "./color-card.vue?vue&type=template&id=f8e784ca"
import script from "./color-card.vue?vue&type=script&lang=js"
export * from "./color-card.vue?vue&type=script&lang=js"
import style0 from "./color-card.vue?vue&type=style&index=0&id=f8e784ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports